/**
 * Get the token from the local storage
 * @returns {string} The token
 */
export function getToken() {
  return localStorage.getItem('token');
}

/**
 * Check if the token is expired
 * @param {string} token - The token
 * @returns {boolean} True if the token is expired, false otherwise
 */
export function isTokenExpired(token) {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = payload.exp * 1000;
    return Date.now() >= expirationTime;
  } catch (error) {
    return true;
  }
}

/**
 * Extract expiration time from token
 * @param {string} token - The JWT token
 * @returns {number} Unix timestamp of expiration time in seconds
 */
export function getTokenExpiryTime(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000;
  } catch (error) {
    return 0;
  }
}

/**
 * Check if the user is admin
 * @param {string} token - The token
 * @returns {boolean} True if the user is admin, false otherwise
 */
export function isAdmin(token) {
  const payload = JSON.parse(atob(token.split('.')[1]));
  return payload.isAdmin;
}

/**
 * Get the current user's ID from the token
 * @param {string} token - The token
 * @returns {string} The user ID
 */
export function getCurrentUserId(token) {
  const payload = JSON.parse(atob(token.split('.')[1]));
  return payload.userId;
}
